<loader *ngIf="loading"></loader>

<ui-table
  #tblEntries
  *ngIf="displayAssets"
  [isWrapped]="false"
  [data]="displayAssets"
  [numberOfRows]="rowsPerPage"
  [totalRecords]="totalRecords"
  [showPaginator]="true"
  (requestUpdate)="onPagination($event)"
  [templates]="[
    {
      title: 'translate.general.image-assets.assetId',
      template: assetId
    },
    {
      title: 'translate.general.image-assets.asset',
      template: preview
    },
    {
      title: 'translate.general.image-assets.assetType',
      template: figureTypeDescr
    },
    {
      title: 'translate.general.image-assets.assetCategory',
      template: typeDescr
    },
    {
      title: 'translate.general.actions',
      template: actions
    }
  ]"
  [more]="expandRow"
  [topEnd]="filterArea"
>
</ui-table>

<ng-template #filterArea>
  <div class="filter-bar l-align-spaceBetween">
    <div class="filter-container">
      <input-wrap [loading]="false">
        <p-select
          [options]="figureTypeList"
          optionLabel="label"
          [(ngModel)]="filterAssetType"
          [resetFilterOnHide]="true"
          [filterPlaceholder]="'translate.general.search' | translate"
          [placeholder]="'translate.general.image-assets.assetType' | translate"
          [filter]="true"
          [showClear]="true"
          (onChange)="onFieldValueChanged($event)"
        >
        </p-select>
      </input-wrap>

      <input-wrap [loading]="classificationCategoriesLoading">
        <p-select
          [options]="classificationCategories"
          optionLabel="label"
          [(ngModel)]="filterCategory"
          [resetFilterOnHide]="true"
          [filterPlaceholder]="'translate.general.search' | translate"
          [placeholder]="'translate.general.image-assets.assetCategory' | translate"
          [filter]="true"
          [showClear]="true"
          (onChange)="onFieldValueChanged($event)"
        >
        </p-select>
      </input-wrap>

      <a *ngIf="displayClearFilter" (click)="clearFilter()">{{
        "translate.general.clear" | translate
      }}</a>
    </div>
  </div>
</ng-template>

<ng-template #assetId let-row="row">{{ row.imageAssetId }}</ng-template>
<ng-template #preview let-row="row">
  <async-img [className]="'ind-img'" [url]="row.s3Url"></async-img>
</ng-template>
<ng-template #figureTypeDescr let-row="row">{{ (row.figureType || '') | titlecase }}</ng-template>
<ng-template #typeDescr let-row="row">
  <div class="cat-phrase-type">
    {{ (row.figureCategory || '-') | titlecase }}
  </div>
</ng-template>
<ng-template #actions let-row="row">
  <div>
    <a (click)="edit($event, row)">{{ "translate.general.edit" | translate }}</a>
    <span class="action-divider">|</span>
    <a (click)="delete($event, row)">{{ "translate.general.delete" | translate }}</a>
  </div>
</ng-template>

<ng-template #expandRow let-row="row">
  <tabs>
    <tab-single
      tabTitle="{{ 'translate.general.image-assets.documents' | translate }}"
      [tabId]="tabIdList?.IMAGE_ASSETS__DOC"
    >
      <cat-entry-docs
        class="t-small"
        *ngIf="row.docs?.length > 0"
        [docs]="row.docs"
      ></cat-entry-docs>
      <div *ngIf="!row.docs || row.docs.length === 0" class="t-small t-alert-info">No documents</div>
    </tab-single>

    <tab-single
      *ngIf="row.metadata?.length"
      tabTitle="{{ 'translate.general.image-assets.metadata' | translate }}"
      [tabId]="tabIdList?.IMAGE_ASSETS__METADATA"
    >
      <ng-container *ngFor="let data of row.metadata">
        <div class="metadata-container">
          <div class="t-small metadata-row">
            <div>{{ getFieldLabel(data.fieldName) }}:</div>
            <div class="metadata-values">{{ displayValues(data) }}</div>
          </div>
        </div>
      </ng-container>
    </tab-single>
  </tabs>
</ng-template>

<modal-popup *ngIf="editMetadata" [title]="'translate.general.image-assets.edit-metadata'" [flexible]="true" [cssClass]="'claim-view-edit-metadata-dialog'" [isOpen]="editMetadata" (onClose)="editMetadata = false">
  <div>
    <loader *ngIf="loadingChanges"></loader>
    <add-doc-metadata 
      [envId]="envId" 
      [catVersionId]="catVersionId" 
      [docMetadataHandler]="docMetadataHandler" 
      [catSystemVersion]="catSystemVersion" 
      [lang]="lang"
      [entityType]="'CLAIM'">
    ></add-doc-metadata>
    <div class="actions">
      <button class="t-button-outline" (click)="cancelEditMetadata()">{{ "translate.general.cancel" | translate }}</button>
      &nbsp;
      <button class="t-button" [disabled]="!enableSaveMetadataChanges" (click)="saveMetadataChanges()">{{ "translate.general.ok" | translate }}</button>
    </div>
  </div>
</modal-popup>
